import React from 'react';

import { localize } from 'wanderu-i18n';

import styles from './LiveCheckMessage.scss';

import type { TFunction } from 'i18next';

interface LiveCheckMessageProps {
    error?: string[];
    notFound?: string[];
    outboundTripIds?: string[];
    priceDown?: string[];
    priceUp?: string[];
    returnTripIds?: string[];
    t: TFunction;
    total?: number;
    unavailable?: string[];
}

function LiveCheckMessage({
    error = [],
    notFound = [],
    outboundTripIds = [],
    priceDown = [],
    priceUp = [],
    returnTripIds = [],
    t,
    total = 0,
    unavailable = [],
}: LiveCheckMessageProps) {
    let message: string | null = null;

    const unavailableOutbound = unavailable.some(
        (tripId: string) => outboundTripIds.includes(tripId)
    );
    const unavailableReturn = unavailable.some(
        (tripId: string) => returnTripIds.includes(tripId)
    );

    if (notFound.length > 0 || error.length > 0) {
        message = t('livecheck-error');
    } else if (unavailable.length === total) {
        message = total === 1
            ? t('one-way-unavailable')
            : t('all-unavailable');
    } else if (unavailableOutbound) {
        message = t('outbound-unavailable');
    } else if (unavailableReturn) {
        message = t('return-unavailable');
    } else if (priceUp.length > 0) {
        /* # of total tripIds, not # of increased prices - we need different
         * language for "The carrier sold out..." vs "A carrier sold out..." */
        message = t('price-increase', { count: total });
    } else if (priceDown.length > 0) {
        message = t('price-decrease');
    }

    return (
        <span className={styles.message}>
            {message}
        </span>
    );
}

export { LiveCheckMessage };
export default localize(LiveCheckMessage, ['t'], 'baseApp');
